import { forwardRef, ComponentProps, useMemo } from 'react'
import { Map as MapGL, MapRef } from 'react-map-gl'
import {
  DEFAULT_BOUNDS,
  DEFAULT_LATITUDE,
  DEFAULT_LONGITUDE,
  DEFAULT_ZOOM,
  MapStyles
} from '../src/constants'

export type MapProps = ComponentProps<typeof MapGL> & { tabIndex?: number }

export const Map = forwardRef<MapRef, MapProps>(
  (
    {
      initialViewState,
      mapStyle,
      maxBounds,
      onLoad,
      tabIndex,
      children,
      ...props
    },
    ref
  ) => {
    const initialView = useMemo(
      () => ({
        zoom: DEFAULT_ZOOM,
        latitude: DEFAULT_LATITUDE,
        longitude: DEFAULT_LONGITUDE,
        ...initialViewState
      }),
      []
    )
    const mapStyleWithDefault = useMemo(
      () => mapStyle || MapStyles.Street,
      [mapStyle]
    )

    const handleOnLoad: MapProps['onLoad'] = (ev) => {
      if (tabIndex === -1) {
        // We try to disable tab navigation, important for accessibility when we use the map in
        // cases where it is for display purposes only and is not interactive. (Ex. plan cover)
        document
          .getElementsByClassName('mapboxgl-canvas')[0]
          .setAttribute('tabindex', '-1')
        document
          .getElementsByClassName('mapboxgl-ctrl-logo')[0]
          .setAttribute('tabindex', '-1')
      }
      onLoad?.(ev)
    }

    return (
      <MapGL
        ref={ref}
        initialViewState={initialView}
        maxBounds={maxBounds || DEFAULT_BOUNDS}
        onLoad={handleOnLoad}
        mapStyle={mapStyleWithDefault}
        logoPosition="bottom-right"
        attributionControl={false}
        {...props}
      >
        {children}
      </MapGL>
    )
  }
)
